<div class="assessment-control" [dir]="data.dir">
    <!-- <formio-loader></formio-loader> -->

    <ul class="breadcrumb">
        <li *ngFor="let item of data.selected">
            <a (click)="goTo(item)">{{item.name}}</a>
        </li>
    </ul>

    <p class="desc">
        {{data.currentLevel.description}}
    </p>

    <span *ngIf="data.currentLevel.hasError && !data.currentLevel.isScoreValid" class="error">
        {{data.currentLevel.error}}
    </span>

    <br />
    <br />
    <div class="row">
        <div class="col-sm-4" *ngFor="let item of data.currentLevel.subCategoriresObject">
            <app-category-card [category]="item" [customOptions]="data.customOptions" [data]="data.data"
                [processConfig]="data.processConfig" (onOpenCategory)="openCategory(item)" [isSub]="true">
            </app-category-card>
            <br />
        </div>
    </div>

    <ng-container *ngIf="data.processConfig.categoryLevelCount == data.currentLevel.levelNumber">
        <div class="row">
            <div class="col-sm-12">
                <div *ngIf="data.currentLevel.questionsAssessmentObject">
                    <p-carousel [value]="data.currentLevel.questionsAssessmentObject" [page]="currentPage"
                        [numVisible]="3" [numScroll]="3" orientation="horizontal" [showIndicators]="true"
                        [showNavigators]="true" dir="ltr">
                        <ng-template let-item pTemplate="item">
                            <app-question-card [class.component-disabled]="formioLoader.loading" [question]="item"
                                [dir]="data.dir" [selectedId]="currentQuestion?._id"
                                (selectQuestion)="selectQuestion(item)">
                            </app-question-card>
                        </ng-template>
                    </p-carousel>
                </div>
                <br />
            </div>
            <div class="col-sm-12">
                <div class="question-container">
                    <app-question-content *ngIf="currentQuestion" [orginalQuestion]="currentQuestion"
                        [processConfig]="data.processConfig" [customOptions]="data.customOptions"
                        [viewOnly]="data.viewOnly" (questionChanged)="changedQuestion($event)"
                        (loading)="questionLoadion($event)"></app-question-content>
                </div>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="data.currentLevel?.levelNumber == 1">
        <br />
        <app-total-statistic [category]="data.currentLevel" [process]="data.processConfig"></app-total-statistic>
        <br />
    </ng-container>

    <app-optional-inputs *ngIf="data.currentLevel?.optionalInputs?.length" [orginalCategory]="data.currentLevel"
        [customOptions]="data.customOptions" [viewOnly]="data.viewOnly" [categoryHasChanged]="categoryHasChanged"
        (changeCategory)="changedCategory($event)">
    </app-optional-inputs>

    <br />
    <br />
    <div [style.textAlign]="'end'">
        <button class="dialog-button dialog-cancel" (click)="close()" [disabled]="formioLoader.loading">
            {{'forms.common.back' | translate}}
        </button>
    </div>
</div>